import { Collapse, Radio  } from "antd";

const { Panel } = Collapse;

export const SSC_ER_VERBIAGE = (
  <Collapse defaultActiveKey={['1']}>
    <Panel header={<span className="uppercase">Test instructions</span>} key="1">
    <p className="mb-4">
      How do you <span className="font-semibold underline">feel</span> when you speak? Because of your speech, are there times when you are
      “<span className="font-semibold">much</span>” or “<span className="font-semibold">very much</span>”&nbsp;
      <span className="font-semibold underline">afraid</span> to talk? Or, is it that you are “<span className="font-semibold">not afraid</span>”,
      “<span className="font-semibold">a little afraid</span>” or “<span className="font-semibold">more than a little afraid</span>” to talk most of the time?
    </p>
    <p className="font-semibold">Let’s practice:</p>
    <p className="mb-4">
      Remember, you have five possible answers: not afraid, a little afraid, more than a little afraid, much afraid or very much afraid.
    </p>
    <p className="font-semibold">
      How do you feel when you are speaking with children at a birthday party?
    </p>
    <p className="mb-4">
      If you would <span className="underline">not</span> be <span className="underline">afraid</span> of talking with children at a birthday party, you would indicate
      '<span className="font-semibold">not afraid</span>'.
    </p>
    <div className="mb-6">
      <p className="font-semibold mb-2">Speaking at a birthday party</p>
      <Radio.Group defaultValue="not_afraid">
        <Radio value="not_afraid">Not afraid</Radio>
        <Radio value="a_little_afraid">A little afraid</Radio>
        <Radio value="more_than_a_little_afraid">More than a little afraid</Radio>
        <Radio value="much_afraid">Much afraid</Radio>
        <Radio value="very_much_afraid">Very much afraid</Radio>
      </Radio.Group>
    </div>
    <p className="mb-4">
      If, for example, speaking with children at a birthday party would make you feel&nbsp;
      <span className="underline">much afraid</span>, you would indicate
      ‘<span className="font-semibold">much afraid</span>’.
    </p>
    <div className="mb-6">
      <p className="font-semibold mb-2">Speaking at a birthday party</p>
      <Radio.Group defaultValue="much_afraid">
        <Radio value="not_afraid">Not afraid</Radio>
        <Radio value="a_little_afraid">A little afraid</Radio>
        <Radio value="more_than_a_little_afraid">More than a little afraid</Radio>
        <Radio value="much_afraid">Much afraid</Radio>
        <Radio value="very_much_afraid">Very much afraid</Radio>
      </Radio.Group>
    </div>
    <p className="font-semibold">Do you have any questions?</p>
    </Panel>
  </Collapse>
)

export const SSC_SD_VERBIAGE = (
  <Collapse defaultActiveKey={['1']}>
    <Panel header={<span className="uppercase">Test instructions</span>} key="1">
    <p>
      How is your <span className="font-semibold">speech</span>? Is speaking <span className="font-semibold">difficult</span> for you?
      Does it often happen to you, that the same sound or same word comes out over and over again?
      (for instance: p-p-p-paper or I - I - I). Are there sounds or words that are stretched out, or that sometimes
      will not come out? (for example: sssssoup or p&nbsp;&nbsp;&nbsp;aper).
      That means, you have “<span className="font-semibold">more than a little trouble</span>”,
      “<span className="font-semibold">much</span>”, or “<span className="font-semibold">very much trouble</span>” talking.
    </p>
    <p>
      Or is speaking <span className="font-semibold">easy</span> for you? Do you have “<span className="font-semibold">no trouble</span>” or only
      “<span className="font-semibold">a little trouble</span>” with your speech? Are sounds or words usually easy for you to say,
      and you talk without difficulty?
    </p>
    <p className="mb-4">Which is true about <span className="font-semibold">your speech</span>?</p>
    <p className="font-semibold">Let’s practice:</p>
    <p className="mb-4">
      Remember, you have five possible answers: no trouble, a little trouble, more than a little trouble, much trouble or very much trouble talking.
    </p>
    <p>
      <span className="font-semibold">How is your speech</span> when you are talking with children at a birthday party?
    </p>
    <p className="mb-4">
      If you would <span className="font-semibold underline">not</span> have <span className="font-semibold underline">trouble</span> getting your sounds or words out when speaking with the children, you would indicate
      ‘<span className="font-semibold">no trouble</span>’.
    </p>
    <div className="mb-6">
      <p>Speaking at a birthday party</p>
      <Radio.Group
        defaultValue="no_trouble"
      >
        <Radio value="no_trouble">No trouble</Radio>
        <Radio value="a_little_trouble">A little trouble</Radio>
        <Radio value="more_than_a_little_trouble">More than a little trouble</Radio>
        <Radio value="much_trouble">Much trouble</Radio>
        <Radio value="very_much_trouble">Very much trouble</Radio>
      </Radio.Group>
    </div>
    <p className="mb-4">
      If, for example, you would have <span className="font-semibold underline">much trouble</span> getting your sounds or words out, you would indicate
      ‘<span className="font-semibold">much trouble</span>’.
    </p>
    <div className="mb-6">
      <p>Speaking at a birthday party</p>
      <Radio.Group
        defaultValue="much_trouble"
      >
        <Radio value="no_trouble">No trouble</Radio>
        <Radio value="a_little_trouble">A little trouble</Radio>
        <Radio value="more_than_a_little_trouble">More than a little trouble</Radio>
        <Radio value="much_trouble">Much trouble</Radio>
        <Radio value="very_much_trouble">Very much trouble</Radio>
      </Radio.Group>
    </div>
    <p className="font-semibold">Do you have any questions?</p>
    </Panel>
  </Collapse>
)

export const BCL_VERBIAGE = (
  <Collapse defaultActiveKey={['1']}>
    <Panel header={<span className="uppercase">Test instructions</span>} key="1">
    <p>
      Children do all sorts of things when they speak. They may point a finger, whisper or shrug their shoulders to make clear what they are saying.
    </p>
    <p className="mb-4">
      However, some children do these things because they <span className="underline italic">expect</span> or&nbsp;
      <span className="underline italic">are having</span> <span className="underline">trouble</span> getting their&nbsp;
      <span className="underline">sounds or words to come out</span> of their mouth.
      They may cough, smack their lips, say “um” or do other things so they won't say things like
      p-p-p-p-p-paper, mmmmmmovie or b_____all.
    </p>
    <p className="mb-4">
      Do <u>you</u> do things to <span className="font-semibold">help your sounds or words come out</span>?
      <br />
      Indicate ‘No’ if you <u>do not</u> do things to keep from having trouble speaking.
      <br />
      Indicate ‘Yes’ <u>only</u> for those things you do because you <span className="underline italic">expect</span> or <span className="underline italic">are having trouble</span> getting your sounds or words out.
    </p>
    <p className="mt-8 mb-4 font-semibold">Let’s practice:</p>
    <p className="font-semibold mb-2">
      To help get your sounds or words come out without trouble, <u>do you</u>.....
    </p>
    <div className="mb-2 flex justify-between max-w-xl">
      <span>hum?.......................................................................................................................</span>
      <Radio.Group
      >
        <Radio value="yes">Yes</Radio>
        <Radio value="no">No</Radio>
      </Radio.Group>
    </div>
    <div className="mb-6 flex justify-between max-w-xl">
      <span>yawn?.......................................................................................................................</span>
      <Radio.Group
      >
        <Radio value="yes">Yes</Radio>
        <Radio value="no">No</Radio>
      </Radio.Group>
    </div>
    Do you have any questions?
    </Panel>
  </Collapse>
)

export const CAT_VERBIAGE = (
  <Collapse defaultActiveKey={['1']}>
    <Panel header={<span className="uppercase">Test instructions</span>} key="1">
    <p className="mb-4">
      The following sentences are about <span className="font-semibold underline">your talking.</span><br />
      Indicate if the sentence about <span className="underline">your</span> talking is mostly 'True' or 'False'.<br />
      Indicate <span className="font-semibold">'True'</span> if you agree with what a sentence says about your speech.<br />
      Indicate <span className="font-semibold">'False'</span> if you do not agree.
    </p>
    <p className="mb-4">
      Remember, answer <span className="font-semibold">'True'</span> if <span className="font-semibold">you agree</span> with what the sentence says and <span className="font-semibold">'False'</span> if <span className="font-semibold">you do not agree.</span>
    </p>
    <p className="mb-4">
      There are no good or bad answers. There are only answers that are 'True' or 'False' about what <span className="font-semibold">you think</span> about <span className="font-semibold">your speech.</span>
    </p>
    <h2 className="font-semibold mt-6 mb-4">Let’s practice:</h2>
    <div className="mb-2 flex justify-between max-w-md">
      <span>I talk too fast……………………………………</span>
      <Radio.Group
      >
        <Radio value="true">True</Radio>
        <Radio value="false">False</Radio>
      </Radio.Group>
    </div>
    <div className="mb-6 flex justify-between max-w-md">
      <span>I don’t speak loud enough………………</span>
      <Radio.Group
      >
        <Radio value="true">True</Radio>
        <Radio value="false">False</Radio>
      </Radio.Group>
    </div>
    <p className="mt-6">Do you have any questions?</p>
    </Panel>
  </Collapse>
)